import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ paddingTop: '64px', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
      <div>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: '5rem', fontWeight: 600, color: 'var(--border)', marginBottom: '16px' }}>404</div>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'var(--navy)', marginBottom: '16px' }}>Page not found</h1>
        <Link to="/" style={{ color: 'var(--amber)', fontWeight: 500, fontSize: '0.9rem' }}>← Back to home</Link>
      </div>
    </div>
  );
}
